import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';

import { Container, Jumbo, Tabs, tokens } from '@treams/treams-ui';

import CycleTemplateEditorID, { CycleTemplateCreator } from './CycleTemplateEditor';
import CycleTemplatesListContainer from './CycleTemplatesListContainer';

export default function CyclesSettings() {
	const { t } = useTranslation();

	return (
		<>
			<Jumbo
				title={t('settings.cycles.title')}
				description={t('settings.cycles.description')}
				footer={
					<Tabs.Container mb="-1px">
						<Tabs.Item
							title={t('settings.cycles.title')}
							path={['/settings/cycles', '/settings/cycles/:id']}
						/>
					</Tabs.Container>
				}
			/>
			<Container pt={`${tokens.gap.page}px`} pb={4}>
				<Switch>
					<Route path="/settings/cycles/new">
						<CycleTemplateCreator />
					</Route>
					<Route path="/settings/cycles/:id">
						{({ match }) => <CycleTemplateEditorID id={match!.params.id!} />}
					</Route>
					<Route>
						<CycleTemplatesListContainer />
					</Route>
				</Switch>
			</Container>
		</>
	);
}
